var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"works__container"},[_c('works-content'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }